<template>
    <div class="container">
        <template>
            <h5>Detalle</h5>
            <div v-if="loading2" class="spinner-border mt-2" role="status"></div><br>
            <!-- <div class="row">
                <div class="col-4">
                    <span>terminada: </span>
                </div>
                <div class="col-8">
                    <input style="float: left !important;" min="0" max="100" class=" ml-5 mb-4" type="number" v-model="row.porcompletada" />
                </div>
            </div> -->
            <textarea v-model="row.justifica" cols="55" rows="10" style="width:90%"></textarea>

            <!-- <textarea v-model="row.descripcio" cols="55" rows="10" style="width:90%"></textarea> -->
            <br>
            <button @click="saveData()" class="btn btn-primary mt-3 ml-3">Guardar</button>
            <button @click="$router.push('historial')" class="btn btn-primary mt-3 ml-3">Cerrar</button>
        </template>
    </div>
</template>

<script>
  import api from "../config/api";

export default {
    data(){
        return{
            loading2: false,
            row: {}
        }
    },
    mounted(){
        this.row = JSON.parse(localStorage.getItem('rowhistorial'))
        console.log(this.row)
    },
    methods:{
        async saveData(){
            this.loading2 = true
            let data={
                justifica : this.row.justifica
            }
            let resultv = await api.request("put", '/BMGES_actualizaHistorial/' + this.row.id_diario,  data);
            let res = resultv.data
            //this.isShow= false
            //await this.getData()
            this.loading2 = false
            this.$router.push('historial')
        }
    }
}
</script>

<style>

</style>